export default __webpack_public_path__ + "static/applet-07-set-1-3575c24c847ae7fea6ffcce82e254aaa.webp";